import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useRecoilState } from "recoil";
import { cashBillCancleModalState } from "../../utils/atom";
import ModalWrapper from "./ModalWrapper";
import Button from "../elements/Button";
import Input from "../elements/Input";
import { toNumber } from "../../utils/CommonFunction";

import { ReactComponent as Remove } from "../../assets/icons/delete-icon.svg";

const CashBillCancleModal = () => {
  const [modal, setModal] = useRecoilState(cashBillCancleModalState);

  const [phone, setPhone] = useState<string>("");

  const handleClose = () => {
    setPhone("");
    setModal(null);
  };

  const handleSubmit = () => {
    setModal(null);
  };

  const handleClick = (value: number) => {
    setPhone(phone + value);
  };

  const handleRemove = () => {
    if (phone.length > 0) setPhone(phone.slice(0, phone.length - 1));
  };

  if (modal === null) return null;

  return (
    <ModalWrapper onClose={handleClose}>
      <Wrapper>
        <Title>현금 결제 취소</Title>
        <Input
          className="light"
          placeholder="휴대폰번호 또는 사업자번호"
          value={phone}
          onChange={(e) => setPhone(toNumber(e.target.value))}
        />
        <DialArea>
          <Dial onClick={() => handleClick(1)}>1</Dial>
          <Dial onClick={() => handleClick(2)}>2</Dial>
          <Dial onClick={() => handleClick(3)}>3</Dial>
          <Dial onClick={() => handleClick(4)}>4</Dial>
          <Dial onClick={() => handleClick(5)}>5</Dial>
          <Dial onClick={() => handleClick(6)}>6</Dial>
          <Dial onClick={() => handleClick(7)}>7</Dial>
          <Dial onClick={() => handleClick(8)}>8</Dial>
          <Dial onClick={() => handleClick(9)}>9</Dial>
          <Dial onClick={handleRemove}>
            <Remove />
          </Dial>
          <Dial onClick={() => handleClick(0)}>0</Dial>
        </DialArea>
        <ButtonArea>
          <Button styleType="line" onClick={handleClose}>
            취소
          </Button>
          <Button disabled={phone === ""} onClick={handleSubmit}>
            취소 처리
          </Button>
        </ButtonArea>
      </Wrapper>
    </ModalWrapper>
  );
};

export default CashBillCancleModal;

const ButtonArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > button {
    max-width: calc(50% - 5px);
  }
`;

const Dial = styled.div`
  width: calc(33.33% - 13.33px);
  height: 50px;
  margin-right: 20px;
  border-radius: 10px;
  background: rgba(34, 34, 37, 0.4);
  font-size: 26px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.06em;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  & > svg {
    width: 32px;
    height: 24px;
  }

  &:nth-of-type(3n) {
    margin-right: 0;
  }

  &:nth-of-type(n + 4) {
    margin-top: 4px;
  }
`;

const DialArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 16px 0 30px;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  color: white;
  margin-bottom: 18px;
`;

const Wrapper = styled.div`
  min-width: 260px;
  width: 260px;
  padding: 22px;
  background: ${(props) => props.theme.color.gray3};
  border-radius: 18px;
  border: solid 1px ${(props) => props.theme.color.gray4};
`;
